import React from 'react';

import { Field, ErrorMessageInstant, Label } from '../FormikCustom';
import check from '../../images/check.png';
export default function BankAccountView() {
    return (
        <section>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="BankName">Bank Name:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field type="text" name="BankName" maxLength="17" disabled={true} className="form-control" />
                        <ErrorMessageInstant name="BankName" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="BankRoutingNumber">Bank Routing Number:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field
                            type="text"
                            name="BankRoutingNumber"
                            maxLength="17"
                            disabled={true}
                            className="form-control"
                        />
                        <ErrorMessageInstant name="BankRoutingNumber" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="BankAccountNumber">Bank Account Number:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field
                            type="text"
                            name="BankAccountNumber"
                            maxLength="17"
                            disabled={true}
                            className="form-control"
                        />
                        <ErrorMessageInstant name="BankAccountNumber" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-value">
                        <img src={check} alt="check" />
                    </div>
                    <div className="col-sm-7 col-form-control"></div>
                </div>
            </div>
        </section>
    );
}
